import { buildCycleBuilderPath, cycleCreateAreaSegment, type CycleDetailOrigin } from "./cycleDetailPaths.ts";

export interface CycleFormTargetsOptions {
    origin: CycleDetailOrigin;
    isBuilderEnabled: boolean;
    workleapPerformanceUrl: string;
}

export interface CycleFormTargets {
    createHref: string;
    getEditHref: (cycleId: string) => string;
    isInApp: boolean;
}

export function resolveCycleFormTargets({ origin, isBuilderEnabled, workleapPerformanceUrl }: CycleFormTargetsOptions): CycleFormTargets {
    if (isBuilderEnabled) {
        return {
            createHref: cycleCreateAreaSegment(origin),
            getEditHref: cycleId => buildCycleBuilderPath(origin, cycleId),
            isInApp: true
        };
    }

    return {
        createHref: `${workleapPerformanceUrl}/app/review-cycles/create`,
        getEditHref: cycleId => `${workleapPerformanceUrl}/app/review-cycles/${cycleId}/edit`,
        isInApp: false
    };
}
